import { IconButton, Paper, Table, TableBody, TableCell, TableFooter, TableHead, TableRow, Tooltip } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import { makeStyles } from "@material-ui/styles";
import { Theme } from "@mui/material";
import React, { useEffect, useState } from "react";
import { FormattedMessage, useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { LayoutSubheader } from "../../../../_metronic";
import TopTableCell from "../../../components/ui/Table/TopTableCell";
import { actions as usersActions } from "../../../store/ducks/users.duck";
import { IAppState } from "../../../store/rootDuck";
import useStyles from "../styles";
import { roles } from "../users/utils/profileForm";
import { TablePaginator } from "../../../components/ui/Table/TablePaginator";

const innerStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: "bold",
    marginBottom: theme.spacing(1),
  },
  crop: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    height: 43.5,
    paddingLeft: 15,
    paddingRight: 15,
    marginTop: theme.spacing(0.5),
    marginBottom: theme.spacing(0.5),
    "&:hover": {
      backgroundColor: "#f4f4f4",
    },
  },
}));

export function MyClients() {
  const [funnelStateEditId, setFunnelStateEditId] = useState(0);

  const innerClasses = innerStyles();
  const classes = useStyles();
  const intl = useIntl();
  const dispatch = useDispatch();
  const me = useSelector((state: IAppState) => state.auth.user);
  const users = useSelector((state: IAppState) => state.users.users);
  const userRole = useSelector((state: IAppState) => state.users.selectedMyClientRole);
  const page = useSelector((state: IAppState) => state.users.page);
  const perPage = useSelector((state: IAppState) => state.users.per_page);
  const total = useSelector((state: IAppState) => state.users.total);
  const history = useHistory();

  const selectedSegments = useSelector((state: IAppState) => state.segment.selectedSegments);

  useEffect(() => {
    me?.id &&
      dispatch(
        usersActions.fetchRequest({
          managerId: me?.id,
          page: page || 1,
          perPage: perPage || 10,
          userRolesId: (userRole === "ALL" ? "" : userRole) ?? "",
          segment1: selectedSegments.segment1 || "",
          segment2: selectedSegments.segment2 || "",
          segment3: selectedSegments.segment3 || "",
        })
      );
  }, [me?.id, userRole, selectedSegments.segment1, selectedSegments.segment2, selectedSegments.segment3]);

  const handleUserClick = (id: number) => {
    history.push(`/user/edit/${id}`);
  };

  return (
    <Paper className={classes.paperWithTable}>
      <LayoutSubheader title={intl.formatMessage({ id: "SUBMENU.MY.CLIENTS" })} />
      <div className={classes.table}>
        <Table aria-label="simple table">
          <TableHead>
            <TableRow>
              <TopTableCell>
                <FormattedMessage id="USERLIST.TABLE.FIO" />
              </TopTableCell>
              <TopTableCell>
                <FormattedMessage id="USERLIST.TABLE.COMPANY" />
              </TopTableCell>
              <TopTableCell>
                <FormattedMessage id="MY.CLIENTS.EMAIL" />
              </TopTableCell>
              <TopTableCell>
                <FormattedMessage id="MY.CLIENTS.PHONE" />
              </TopTableCell>
              <TopTableCell>
                <FormattedMessage id="USERLIST.TABLE.SEGMENT" />
              </TopTableCell>

              <TopTableCell>
                <FormattedMessage id="USERLIST.TABLE.ROLE" />
              </TopTableCell>
              <TopTableCell></TopTableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {users &&
              users.map(item => (
                <TableRow key={item.id}>
                  <TableCell>
                    <div>
                      <div className={classes.topAndBottomMargin1}>
                        {`${item.firstname ?? ""} ${(item.lastname || item.surname) ?? ""}`}
                      </div>
                      {item.company && <div className={classes.topAndBottomMargin1}>{`${item.company.short_name || ""}`}</div>}
                    </div>
                  </TableCell>
                  <TableCell>
                    {item.company ? (
                      <div>
                        <div className={classes.topAndBottomMargin1}>{item?.company?.full_name}</div>
                        <div className={classes.topAndBottomMargin1}>{`${item.company.short_name || ""}`}</div>
                      </div>
                    ) : (
                      <div style={{ textAlign: "center" }}>-</div>
                    )}
                  </TableCell>
                  <TableCell>
                    <div>
                      <div className={classes.topAndBottomMargin1}>{item.email}</div>
                    </div>
                  </TableCell>
                  <TableCell>{!!item.phone && <div className={classes.topAndBottomMargin1}>{item.phone}</div>}</TableCell>

                  <TableCell>
                    <div>
                      <div className={classes.topAndBottomMargin1}>{`${item.segment1 ?? ""} ${item.segment2 ? `/ ${item.segment2}` : ""} ${
                        item.segment3 ? `/ ${item.segment3}` : ""
                      }`}</div>
                    </div>
                  </TableCell>
                  <TableCell>{roles.find(role => role.id === item.roles[0])?.value}</TableCell>
                  <TableCell>
                    <Tooltip
                      title={intl.formatMessage({
                        id: "USERLIST.TOOLTIP.EDIT",
                      })}
                    >
                      <IconButton size="medium" color="primary" onClick={() => history.push(`/user/edit/${item.id}`)}>
                        <EditIcon />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                </TableRow>
              ))}
          </TableBody>
          <TableFooter>
            <TableRow>
              <TablePaginator
                page={page}
                realPerPage={users?.length || 0}
                perPage={perPage}
                total={total}
                fetchRows={(page, perPage) =>
                  dispatch(
                    usersActions.fetchRequest({
                      managerId: me?.id,
                      page,
                      perPage,
                      userRolesId: (userRole === "ALL" ? "" : userRole) ?? "",
                      segment1: selectedSegments.segment1 || "",
                      segment2: selectedSegments.segment2 || "",
                      segment3: selectedSegments.segment3 || "",
                    })
                  )
                }
              />
            </TableRow>
          </TableFooter>
        </Table>
      </div>
    </Paper>
  );
}
